import CalcMain from "@/components/Calc/CalcMain"
import TotalSumm from "@/components/Calc/TotalSumm"

export default [
    CalcMain,
    TotalSumm
]